import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    type: String,
    message: String,
    status: String,
  }

  connect() {
    App.displayFlash(this.typeValue, this.messageValue, this.statusValue)
    this.element.remove()
  }
}
